<template>
  <div>
    <payment-list :cate="cate" ref='paymentList'></payment-list>
  </div>
</template>

<script>
import PaymentList from "@/views/payment2.0/PaymentList.vue";
export default {
  name: "Payment",
  components: {
    PaymentList,
  },
  data() {
    return {
      cate: "Payment",
    };
  },
  mounted(){
    this.$refs.paymentList.init()
  }
};
</script>